module.exports = __webpack_public_path__ + "static/media/identity-abstraack-flower-social.3d4e66f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-abstraack-flower-social.jpg
// module id = 54
// module chunks = 0